
















import blockMixin from './../BlockMixin.vue'

export default {
  name: 'video'

  mixins: [blockMixin]

  data: -> {
    fields: {
      plattform: ''
      url: ''
      id: ''
    }
  }

  mounted: ->
    this.$el.querySelector('.bb8-block-video-url').focus() if this.block.fields.url.length <= 0

  methods: {
    loadVideo: (event) ->
      url = event.target.value
      return if url == ''
      this.block.fields.url = url

      id = this.getVideoId(url)
      this.block.fields.id = id if id

    getVideoId: (url) ->
      rawUrl = url.replace(/^(https?:)?\/\/(www\.)?/, '')
      rawUrl = rawUrl.split('&')[0]
      rawUrl = rawUrl.split('#')[0]
      prefixes = []

      if rawUrl.startsWith('youtu')
        this.block.fields.plattform = 'youtube'
        prefixes = ['youtube.com/watch?v=', 'youtu.be/', 'youtube.com/embed/']
      else if rawUrl.startsWith('vimeo.com')
        this.block.fields.plattform = 'vimeo'
        prefixes = ['vimeo.com/']

      for prefix in prefixes
        return rawUrl.substr(prefix.length) if rawUrl.indexOf(prefix) == 0
      return undefined

    removeBlock: (event, checkUrl = false) ->
      return if checkUrl && event.target.value.length > 0
      this.$emit('remove-block', this.index)
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/blocks/VideoBlock.vue